import React from 'react';

const UserList = () => {
    return (
        <div>
            <h1>User List on progress...</h1>
        </div>
    );
};

export default UserList;